module.exports = __webpack_public_path__ + "static/media/complexPic2.6622cd36.png";